function AddHelpers(addon){
    this.fadeEleOut = (ele) => {
        while(ele.classList.contains('fadeIn')){
            ele.classList.remove('fadeIn');
        }
        ele.classList.add('fadeOut');
        ele.classList.remove('o-0');
    }
    this.fadeEleIn = (ele) => {
        while(ele.classList.contains('fadeOut')){
            ele.classList.remove('fadeOut');
        }
        ele.classList.add('fadeIn');
    }
    this.showEle = (ele) => {
        while(ele.classList.contains('d-none')){
            ele.classList.remove('d-none');
        }
    }
    this.hideEle = (ele) => {
        ele.classList.add('d-none');
    }

    this.fadeRefOut = (ref) => {
        while(ref.current.classList.contains('fadeIn')){
            ref.current.classList.remove('fadeIn');
        }
        while(ref.current.classList.contains('o-0')){
            ref.current.classList.remove('o-0');
        }
        ref.current.classList.add('fadeOut');
    }
    this.fadeRefIn = (ref) => {
        while(ref.current.classList.contains('fadeOut')){
            ref.current.classList.remove('fadeOut');
        }
        ref.current.classList.add('fadeIn');
    }
}

export default AddHelpers;